<avi-dropdown
    name="timeframe-selector"
    class="timeframe-selector"
    [(ngModel)]="timeframe"
    [options]="options"
    prepend="{{ l10nKeys.displayLabel | vtranslate }}"
    placeholder="{{ l10nKeys.selectTimeframePlaceholder | vtranslate }}"
    [required]="true"
    (ngModelChange)="onTimeframeChangeFromTheSelector($event)"
></avi-dropdown>
